<template>
  <div>
    <TournamentGameListModal />
    <DelayedGameModal />
    <div class="box-score-top-container">
      <div class="left-section flex-row">
        <div class="switch-game cursor-pointer" @click="openGameModal">
          <span>Switch Game</span>
          <h6 class="text-capitalize">{{ singleGame?.game_name }}</h6>
        </div>
        <div v-if="singleGame.game_scores?.length != 0">
          <div class="opponent-tag" v-if="
            singleGame.game_scores?.some((team) => team.team_type === 1)
          ">
            <h6 :class="{
              'winner-text': singleGame.status === 2 && visitTeamWin
            }">
              #{{
                singleGame.game_scores?.find(
                  (team) => team.team_type === 1
                )?.teams.team_sr_no
              }}:
              {{
                singleGame.game_scores?.find(
                  (team) => team.team_type === 1
                )?.team.team_name
              }}
            </h6>
            <div class="custom-avatar" 
              v-if="singleGame.game_scores?.find(team => team.team_type === 1)?.team.team_avatar == null"
              :style="{ backgroundColor: getRandomColor() }">
              {{ getInitials(singleGame.game_scores?.find(team => team.team_type === 1)?.team.team_name) }}
            </div>
            <div class="team-image" v-else>
              <div class="users-notification" v-if="imgLoader == 1">
                <img src="../../../assets/loader.gif" alt="" />
              </div>
              <img @load="onImageLoad" v-if="singleGame.game_scores?.find(
                (team) => team.team_type === 1
              )?.team.team_avatar == null" :src="team_image" alt="" />
              <img @load="onImageLoad" v-if="singleGame.game_scores?.find(
                (team) => team.team_type === 1
              )?.team.team_avatar != null" :src="url + singleGame.game_scores?.find(
                (team) => team.team_type === 1
              )?.team.team_avatar" alt="" />
            </div>
            <span class="score-text">{{ receivedScores.visitScore }}</span>
            <img :src="arrow_left" class="arrow-image" alt="arrow-left" v-if="
              singleGame.status === 1 &&
              singleGame.game_scores &&
              singleGame.game_scores?.find(
                (team) =>

                  team.team_type == 1 &&
                  team.batting_flag == 1
              )
            " />
            <img :src="cup" alt="cup"
              v-if="singleGame.status === 2 && visitTeamWin" />
          </div>
        </div>
        <div class="opponent-data" v-else>
          <h6>
            #{{
              singleGame.team_one?.team_sr_no
            }}:
            {{
              singleGame.team_one?.team_data?.team_name
            }}
          </h6>
          <div class="custom-avatar" 
            v-if="singleGame.team_one?.team_data?.team_avatar == null"
            :style="{ backgroundColor: getRandomColor() }">
            {{ getInitials(singleGame.team_one?.team_data?.team_name) }}
          </div>
          <div class="team-image" v-else>
            <div class="users-notification" v-if="imgLoader == 1">
              <img src="../../../assets/loader.gif" alt="" />
            </div>
            <img @load="onImageLoad" v-if="singleGame.team_one?.team_data?.team_avatar == null" :src="team_image"
              alt="" />
            <img @load="onImageLoad" v-if="singleGame.team_one?.team_data?.team_avatar != null"
              :src="url + singleGame.team_one?.team_data?.team_avatar" alt="" />
          </div>
          <span>-</span>
        </div>
      </div>

      <div class="center-content">
        <span>{{ singleGame.start_time}}</span>
        <div class="begin-btn" v-if="singleGame.game_scores.length == 0">Yet to Begin</div>
        <div class="begin-btn inning-btn"
          v-if="singleGame.game_scores.length != 0 && singleGame.status === 1 && singleGame.game_delayed == 0">
          Inning:
          {{ singleGame.game_scores[0].end_inning_flag }}</div>
        <div class="begin-btn final-btn" v-if="singleGame.game_scores.length != 0 && singleGame.status === 2">
          Final</div>
        <div class="begin-btn delayed-btn"
          v-if="singleGame.game_scores.length != 0 && singleGame.status === 1 && singleGame.game_delayed == 1">
          Delayed</div>
      </div>

      <div class="right-section flex-md-row">
        <div v-if="singleGame.game_scores?.length != 0">
          <div class="opponent-tag" v-if="
            singleGame.game_scores?.some((team) => team.team_type === 2)
          ">
            <img :src="arrow_left" class="arrow-image" alt="arrow-left" v-if="
              singleGame.status === 1 &&
              singleGame.game_scores &&
              singleGame.game_scores?.find(
                (team) =>

                  team.team_type == 2 &&
                  team.batting_flag == 1
              )
            " />
           <img :src="cup" alt="cup" v-if="singleGame.status === 2 &&  homeTeamWin" />
            <span class="score-text">{{ receivedScores.homeScore }}</span>
            <div class="custom-avatar" 
              v-if="singleGame.game_scores?.find(team => team.team_type === 2)?.team.team_avatar == null"
              :style="{ backgroundColor: getRandomColor() }">
              {{ getInitials(singleGame.game_scores?.find(team => team.team_type === 2)?.team.team_name) }}
            </div>
            <div class="team-image" v-else>
              <div class="users-notification" v-if="imgLoader == 1">
                <img src="../../../assets/loader.gif" alt="" />
              </div>
              <img @load="onImageLoad" v-if="singleGame.game_scores?.find(
                (team) => team.team_type === 2
              )?.team.team_avatar == null" :src="team_image" alt="" />
              <img @load="onImageLoad" v-if="singleGame.game_scores?.find(
                (team) => team.team_type === 2
              )?.team.team_avatar != null" :src="url + singleGame.game_scores?.find(
                (team) => team.team_type === 2
              )?.team.team_avatar" alt="" />
            </div>
            <h6 :class="{
              'winner-text': singleGame.status === 2 && homeTeamWin
            }">
              #{{
                singleGame.game_scores?.find(
                  (team) => team.team_type === 2
                )?.teams.team_sr_no
              }}:
              {{
                singleGame.game_scores?.find(
                  (team) => team.team_type === 2
                )?.team.team_name
              }}
            </h6>
          </div>
        </div>
        <div class="opponent-data" v-else>
          <span>-</span>
          <div class="custom-avatar" 
            v-if="singleGame.team_two?.team_data?.team_avatar == null"
            :style="{ backgroundColor: getRandomColor() }">
            {{ getInitials(singleGame.team_two?.team_data?.team_name) }}
          </div>
          <div class="team-image" v-else>
            <div class="users-notification" v-if="imgLoader == 1">
              <img src="../../../assets/loader.gif" alt="" />
            </div>
            <img @load="onImageLoad" v-if="singleGame.team_two?.team_data?.team_avatar == null" :src="team_image"
              alt="" />
            <img @load="onImageLoad" v-if="singleGame.team_two?.team_data?.team_avatar != null"
              :src="url + singleGame.team_two?.team_data?.team_avatar" alt="" />
          </div>
          <h6>
            #{{
              singleGame.team_two?.team_sr_no
            }}:
            {{
              singleGame.team_two?.team_data?.team_name
            }}
          </h6>
        </div>
        <div>
          <router-link class="m-0" :to="{
            name: 'AssociationSingleEventDetail',
            params: { id: singleGame?.event?.guid },
          }">
            <h6 class="text-right">
              {{ singleGame.event.eventName }}
            </h6>
          </router-link>

          <h6 class="text-right">{{ singleGame?.tournament?.tournamentName }}</h6>
        </div>
      </div>
    </div>
    <div class="back-to-event-div d-flex align-items-center justify-content-between flex-wrap">
      <router-link class="m-0" :to="{
            name: 'AssociationSingleEventDetail',
            params: { id: singleGame?.event?.guid },
          }">
        <h6>
          <img src="../../../assets/Svg/back-arrow.svg" alt="back-arrow" class="mr-1" />Back to Event - <span>{{
            singleGame.event.eventName }}</span>
        </h6>
      </router-link>
      <div>{{ singleGame.delayed_reason }}</div>
      <div class="d-flex align-items-center justify-content-end gap-8" v-if="this.singleGame?.status == 2">
        <button class="main-delete-btn"
          v-if="this.singleGame?.status == 2 && !this.singleGame?.locked && currentIsAdmin === '1'" @click="lockGame">
          Lock Game
        </button>
        <button class="main-delete-btn"
          v-if="this.singleGame?.status == 2 && currentIsAdmin === '1' && this.singleGame?.locked" @click="unlockGame">
          Unlock Game
        </button>
        <button class="manage-btn"
          v-if="this.singleGame?.status == 2 && !this.singleGame?.locked && (currentIsAdmin === '1' || currentIsUmpire === '1')"
          @click="restartGame">
          Reopen Game
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DelayedGameModal from "../Modals/DelayedGameModal.vue";
import TournamentGameListModal from "./TournamentGameListModal.vue";
import { EventBus } from "@/eventBus"; // Import EventBus

export default {
  components: {
    TournamentGameListModal,
    DelayedGameModal,
  },
  name: "ScoreTop",
  data() {
    return {
      timer: null,
      gameOption: false,
      teamOneData: null,
      teamTwoData: null,
      homeTeamWin: false,
      visitTeamWin: false,
      user_id: localStorage.getItem("userId"),

      arrow_left: require("../../../assets/Svg/arrow-left.svg"),
      imgLoader: 1,
      cup: require("../../../assets/Svg/cup.svg"),
      url: this.$groupAvatarStorageURL,
      team_image: require("../../../assets/Svg/people.svg"),
      receivedScores: { homeScore: 0, visitScore: 0 }
    };
  },
  props: {
    singleGame: {
      type: Object,
    },
    currentIsAdmin: {
      type: String,
    },
    currentIsUmpire: {
      type: String,
    },
    scores: {
      type: Array,
    },
    association_id: {
      type: Number,
    },
  },
  created() {
    this.extractTeamData();
    EventBus.$on("scoreUpdated", (data) => {
      this.receivedScores = data;
      this.homeTeamWin = this.receivedScores.homeScore > this.receivedScores.visitScore;
      this.visitTeamWin = this.receivedScores.visitScore > this.receivedScores.homeScore;
    });
  },
  methods: {
    getInitials(name) {
      return name ? name.charAt(0).toUpperCase() : "?";
    },
    getRandomColor() {
      const colors = [
        "#FCE4EC",
        "#E3F2FD",
        "#F1F8E9",
        "#FFF8E1",
        "#EDE7F6",
        "#FFEBEE",
        "#F9FBE7",
        "#FFF3E0",
        "#ECEFF1",
        "#FFECB3",
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    delayedGameModal(singleGame) {
      this.$root.$emit("openDelayedGameTournamentModal", singleGame);
    },
    onImageLoad() {
      this.imgLoader = 0;
    },
    lockGame: function () {
      this.$confirm(
        "About to lock the game which will restrict score modification for the game. Admin can unlock it again at any time to modify the scores. Continue ?",
        "Lock Game."
      ).then(() => {
        this.gameActionLoader = 1;
        var formData = new FormData();
        formData.append("tournament_game_id", this.singleGame.id);
        axios
          .post(
            process.env.VUE_APP_API_URL + "tournaments/game/lockGame",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            if (response.data.statusCode == 404) {
              // this.$alert("Delayed game can not be locked").then(() => {
              this.$alert(response.data.message, "Error");
              this.$router.push({ name: "Teams" });
              //  });
            } else if (response.data.statusCode == 300) {
              alert(response.data.message);
            } else if (response.data.statusCode == 500) {
              alert(response.data.message);
            } else {
              let loader = this.$loading.show({
                container: this.fullPage ? null : this.$refs.formContainer,
                color: "#ffffff",
                backgroundColor: "#333",
                opacity: 0.6,
              });
              loader.hide();
              this.$root.$emit("showTounamentGameScore");
            }
          });
      });
    },

    unlockGame: function () {
      this.$confirm(
        "About to unlock the game which will allow to modify the scores. Continue ?",
        "Unlock Game."
      ).then(() => {
        this.gameActionLoader = 1;
        var formData = new FormData();
        formData.append("tournament_game_id", this.singleGame.id);
        axios
          .post(
            process.env.VUE_APP_API_URL + "tournaments/game/unlockGame",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            if (response.data.statusCode == 300) {
              alert(response.data.message);
            } else if (response.data.statusCode == 404) {
              this.$alert(response.data.message, "Error");
              this.$router.push({ name: "Teams" });
            } else if (response.data.statusCode == 500) {
              alert(response.data.message);
            } else {
              let loader = this.$loading.show({
                container: this.fullPage ? null : this.$refs.formContainer,

                color: "#ffffff",
                backgroundColor: "#333",
                opacity: 0.6,
              });
              // this.getScores();

              loader.hide();
              // this.gameActionLoader = 0;
              this.$root.$emit("showTounamentGameScore");
            }
          });
      });
    },
    restartGame: function () {
      this.$confirm(
        "Are you sure to restart this Game. Continue ?",
        "Restart Game."
      ).then(() => {
        this.gameActionLoader = 1;
        var formData = new FormData();
        formData.append("tournament_game_id", this.singleGame.id);
        formData.append("association_id", this.singleGame.association_id);
        axios
          .post(
            process.env.VUE_APP_API_URL + "tournaments/game/reopenGame",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            if (response.data.statusCode == 300) {
              this.$alert(response.data.message);
            } else if (response.data.statusCode == 404) {
              this.$alert(response.data.message, "Error");
              this.$router.push({ name: "Teams" });
            } else if (response.data.statusCode == 500) {
              this.$alert(response.data.message);
            } else if (response.data.statusCode == 403) {
              this.$alert(response.data.message);
              window.location.reload();
            } else {
              let loader = this.$loading.show({
                container: this.fullPage ? null : this.$refs.formContainer,

                color: "#ffffff",
                backgroundColor: "#333",
                opacity: 0.6,
              });
              // this.getScores();
              this.gameActionLoader = 0;
              loader.hide();
              this.$root.$emit("showTounamentGameScore");
            }
          });
      });
    },
    extractTeamData() {
      if (
        this.singleGame &&
        this.singleGame.game_scores &&
        this.singleGame.game_scores.length > 0
      ) {
        const gameScores = this.singleGame.game_scores;
        const teamOneId = this.singleGame.team_1_id;
        const teamTwoId = this.singleGame.team_2_id;

        // Find team data for team_one
        const teamOneScore = gameScores.find(
          (score) => score.team_id === teamOneId
        );
        if (teamOneScore) {
          const teamOneData =
            teamOneScore.team_type === 1
              ? this.singleGame.team_one
              : this.singleGame.team_two;
          this.teamOneData = {
            teamName: teamOneData.team_data.team_name,
            teamSrNo: teamOneData.team_sr_no,
          };
        }

        // Find team data for team_two
        const teamTwoScore = gameScores.find(
          (score) => score.team_id === teamTwoId
        );
        if (teamTwoScore) {
          const teamTwoData =
            teamTwoScore.team_type === 1
              ? this.singleGame.team_one
              : this.singleGame.team_two;
          this.teamTwoData = {
            teamName: teamTwoData.team_data.team_name,
            teamSrNo: teamTwoData.team_sr_no,
          };
        }
      }
    },
    openParkGoogleMap(item) {
      let urlSuffix;
      if (item["lat"] && item["lng"]) {
        const strlatLng = item["lat"] + "," + item["lng"];
        urlSuffix = strlatLng;
      } else {
        urlSuffix = encodeURIComponent(item["address"] + ", " + item["city"] + ", " + item["zipCode"]);
      }
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },
    openGoogleMap(item) {
      const strlatLng = item["lan"] + "," + item["long"];
      const urlSuffix = strlatLng
        ? strlatLng
        : item["address"] + ", " + item["city"] + ", " + item["zipCode"];

      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },
    openGameModal: function () {
      this.$root.$emit("openTournamentGamesDataModal", this.singleGame);
    },

    startTimer() {
      if (this.singleGame.status === 1) {
        this.timer = setInterval(() => {
          if (this.singleGame.game_overed === 0) {
            this.decrementTime();
          } else {
            this.incrementOverTime();
          }
        }, 1000);
      }
    },
    decrementTime() {
      const timeParts = this.singleGame.remaining_time.split(":").map(Number);
      let [hours, minutes, seconds] = timeParts;

      if (hours === 0 && minutes === 0 && seconds === 0) {
        clearInterval(this.timer);
        this.singleGame.game_overed = 1;
        this.$root.$emit("showTounamentGameScore");
        return;
      }

      seconds--;
      if (seconds < 0) {
        seconds = 59;
        minutes--;
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
      }

      this.singleGame.remaining_time = this.formatTime(hours, minutes, seconds);
    },
    incrementOverTime() {
      const timeParts = this.singleGame.total_over_time.split(":").map(Number);
      let [hours, minutes, seconds] = timeParts;

      seconds++;
      if (seconds === 60) {
        seconds = 0;
        minutes++;
        if (minutes === 60) {
          minutes = 0;
          hours++;
        }
      }

      this.singleGame.total_over_time = this.formatTime(hours, minutes, seconds);
    },
    formatTime(hours, minutes, seconds) {
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style></style>
